import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/user-access-report',
};

export const getColumns = () => [
  {
    id: 'visitTime',
    label: 'Date/Time',
    customValue: (val) => format(new Date(val.visitTime), 'dd MMMM yyyy pp'),
    align: 'left',
    nameForSort: 'visit_date',
  },
  { id: 'facilityName', label: 'Facility Name', align: 'center', nameForSort: 'facility_name' },
  { id: 'className', label: 'Class', align: 'center', disableSort: true },
  { id: 'userName', label: 'Name', align: 'center', disableSort: true },
  { id: 'userSurname', label: 'Surname', align: 'center', disableSort: true },
  { id: 'corporationName', label: 'Corporation', align: 'center', nameForSort: 'corporation_name' },
  { id: 'userSex', label: 'Sex', align: 'center', nameForSort: 'user_sex' },
  { id: 'userAge', label: 'Age', align: 'center', nameForSort: 'user_age' },
];

export const getFilters = ({ removeDuplicates, searchByName, region, facilityName, dateRange, corpName, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name...',
    action: searchByName.change,
    defaultValue: searchByName.defaultValue,
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Remove Duplicates',
    value: removeDuplicates.value === 'true',
    action: removeDuplicates.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'facility',
    type: 'select',
    label: 'Facility',
    value: facilityName.value,
    action: facilityName.change,
    items: options?.facilityNames?.length ? ['all', ...options.facilityNames] : ['all'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'corpName',
    type: 'autocomplete',
    label: 'Corporation',
    value: corpName.value,
    action: corpName.change,
    items: options?.corporationNames?.length ? ['All', 'Public', ...options.corporationNames] : ['All', 'Public'],
  },
];
